<script lang="ts" setup>
import type { EmblaCarouselType } from 'embla-carousel'
import emblaCarouselVue from 'embla-carousel-vue'

import CarouselButton from '~/components/carousels/CarouselButton.vue'

withDefaults(
  defineProps<{
    showButtons?: boolean
    showDots?: boolean
  }>(),
  { showButtons: true, showDots: false }
)

const [emblaRef, emblaApi] = emblaCarouselVue({ align: 'start' })

const canScrollNext = ref(false)
const canScrollPrev = ref(false)
const scrollSnaps = ref<number[]>([]);
const selectedIndex = ref(0)

onMounted(() => {
  if (!emblaApi?.value) {
    return
  }

  emblaApi.value.on('init', onSelect)
  emblaApi.value.on('reInit', onSelect)
  emblaApi.value.on('select', onSelect)
})

function onSelect (emblaApi: EmblaCarouselType): void {
  canScrollNext.value = emblaApi.canScrollNext() ?? false
  canScrollPrev.value = emblaApi.canScrollPrev() ?? false
  scrollSnaps.value = emblaApi.scrollSnapList() ?? []
  selectedIndex.value = emblaApi.selectedScrollSnap() ?? 0
}

function scrollNext (): void {
  emblaApi?.value?.scrollNext()
}

function scrollPrev (): void {
  emblaApi?.value?.scrollPrev()
}
</script>

<template>
  <div class="container gallery-container relative">
    <div ref="emblaRef" class="embla-content z-[1] overflow-hidden px-2 md:px-0">
      <slot />
    </div>

    <CarouselButton v-if="showButtons && canScrollPrev" is-gallery :is-next="false" @on-button-click="scrollPrev" />

    <CarouselButton v-if="showButtons && canScrollNext" is-gallery is-next @on-button-click="scrollNext" />

    <div v-if="showDots" class="absolute bottom-0 left-0 -m-1 flex w-full justify-center lg:hidden">
      <div
        v-for="x in scrollSnaps.length"
        :key="x"
        class="m-1 box-border size-2 rounded-full border border-solid border-main-aluminum bg-white"
        :class="{ '!bg-main-aluminum': x === selectedIndex + 1 }"
      />
    </div>
  </div>
</template>
